"use strict";

exports.__esModule = true;
exports["default"] = _default;

var _react = require("react");

var _store = require("./store");

function _default(name, func, differs) {
  (0, _react.useEffect)(function () {
    (0, _store.addListener)(name, func);
    return function () {
      (0, _store.removeListener)(name, func);
    };
  }, differs);
}